import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FavoritesController from '../../../FavoritesController';
import Icon from '@projeccions-pdc/react-icon';
import AppContext from '../../../AppContext';
import { cloneDeep } from 'lodash';
import './Favorites.css';

class Favorites extends Component {
    constructor(props) {
        super(props);
        this.state = {
            favorites: []
        };

        let appContext = new AppContext();
        let platformId = appContext.getPlatformId();
        let myInfo = appContext.getMyInfo();
        let userSub = myInfo ? myInfo.userSub : 'userAnonim';
        this._FavoritesController = new FavoritesController(platformId, userSub);
    }

    componentDidMount() {
        this.refreshFavs();
    }

    componentDidUpdate() {
        if (this.props.currentContent && this.state.oldCurrentContent && this.props.currentContent.contentId !== this.state.oldCurrentContent.contentId) {
            this.refreshFavs();
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.currentContent && state.oldCurrentContent && props.currentContent.contentId !== state.oldCurrentContent.contentId) {
            return {
                oldCurrentContent: this.props.currentContent
            };
        }
        return null;
    }

    refreshFavs = async () => {
        let favs = await this._FavoritesController.getFavorites(true);
        this.setState({ favorites: favs });
    }

    handleFavsClick = async () => {
        try {
            let request;
            let newFavs = cloneDeep(this.state.favorites);
            if (this.isFav()) {
                newFavs = newFavs.filter((fav) => {
                    return fav.contentId !== this.props.currentContent.contentId;
                });
                request = this._FavoritesController.removeFavorite(this.props.currentContent.contentId);
            } else {
                if (this.props.currentContent && this.props.currentContent.contentId) {
                    newFavs.push(this.props.currentContent);
                    request = this._FavoritesController.addFavorite(this.props.currentContent.contentId);
                }
            }
            this.setState({ favorites: newFavs });

            let response;
            if (request) {
                response = await request;
            }
            // console.log('add or remove fav response', response);
            if (response && response.favorites) {
                this.setState({ favorites: response.favorites });
            }
        } catch (err) {
            console.log('error edding or removing fav', err.message);
        }
    }

    isFav = () => {
        if (!this.props.currentContent) return false;
        let result = false;
        for (let i = 0; i < this.state.favorites.length && !result; i++) {
            let currFav = this.state.favorites[i];
            if (currFav.contentId === this.props.currentContent.contentId) {
                result = true;
            }
        }
        return result;
    }

    render() {
        if (this.props.currentContent && this.props.currentContent.contentId !== 'MAIN-CATEGORY') {
            if (this.props.children !== undefined) {
                return (
                    <div style={{ display: 'inline-block' }} data-id="favs-button" onClick={this.handleFavsClick}>
                        {this.props.children(this.isFav())}
                    </div>
                );
            } else {
                return (
                    <div data-id="favs-button">
                        <div className={'fe-menu-button fe-favs-button'} onClick={this.handleFavsClick}>
                            {this.isFav() ?
                                <Icon name='md-star' size={'20px'} />
                                :
                                <Icon name='md-star-outline' size={'20px'} />
                            }
                        </div>
                    </div>
                );
            }
        } else {
            return '';
        }
    }
}
Favorites.propTypes = {
    currentContent: PropTypes.object,
    children: PropTypes.func,
};

export default Favorites;